export default "__VITE_ASSET__C088s69r__"